module.exports = __webpack_public_path__ + "static/media/home-bg.be70d7dd.jpg";